// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3_yLQ","calendarButtons":"ClockData_calendarButtons__1F1BL"};